import { User } from "../components/users/types";
import { masqueradeToken, userIsFPEmployee } from "../util";
import { RBACAccessLevel, RBACDomain, RolePermissions } from "./types";

export const userHasAccess = (
  user: User | undefined,
  permissions: RolePermissions | undefined,
  domain: RBACDomain,
  accessLevel: RBACAccessLevel,
): boolean => {
  if (userIsFPEmployee() || masqueradeToken()) {
    return true;
  }

  if (permissions === undefined) {
    return false;
  }

  if (user === undefined || user.role.length === 0) {
    return false;
  }

  if (!permissions[user.role]) {
    return false;
  }

  const rolePermissions = permissions[user.role];
  if (!rolePermissions[domain]) {
    return false;
  }

  const domainAccessLevels = rolePermissions[domain];
  return domainAccessLevels.includes(accessLevel);
};
